import React, { FC, Fragment, useEffect, useRef, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { FontIcon } from "@fluentui/react/lib/Icon";
import { DefaultButton } from "@fluentui/react";
import SofIcon from "../common/Icons";
import { useZxing } from "react-zxing";
import { Post, Get } from "../../api/apiUtils";
import { TruckNomination } from "../../models/Nomination";
import moment from "moment";
import { QrScanView } from "../../models/QrScanView";
import { QrReader } from "react-qr-reader";
export const QRScanner = (props: any) => {
  const { classes, showQRModal, setShowQRModal } = props;
  const [qrState, setQRState] = useState<Number>(QrScanView.QRSCAN);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [result, setResult] = useState<string | null>(null);
  const [qrValidationMessage, setQRValidationMessage] = useState<string | null>(
    ""
  );

  const [linehandlingData, setLineHandlingData] =
    useState<TruckNomination | null>(null);
  const [isScanning, setIsScanning] = useState(true);

  const handleQRScan = async () => {
    setIsLoading(true);
    try {
      const response = await Get(
        `/api/nomination/${result}/qrcode`,
        false,
        true
      );
      if (response.status == 422 || response.status == 404) {
        if (response.status == 422) {
          let errMsg = await response.json();
          setQRValidationMessage(errMsg.message);
        }

        setQRState(QrScanView.QRNOTRECOGNIZED);
        setIsLoading(false);
        return;
      }
      setLineHandlingData(await response.json());
      setQRState(QrScanView.TRANSFERTOARRIVE);
      setIsLoading(false);
    } catch (err) {
      setQRState(QrScanView.QRNOTRECOGNIZED);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (result != null) {
      handleQRScan();
    }
  }, [result]);

  const handleTransferToArrive = async () => {
    let action = {
      status: 1,
    };

    var nominationNo = linehandlingData?.nominationNo;

    const response = await Post(`api/nomination/${nominationNo}/status`, null);
    setIsLoading(false);
    if (response.ok) {
      setQRState(QrScanView.ARRIVED);
    }
  };

  const handleReinitialize = () => {
    // setQRState(0);
    // setResult(null);
    setQRValidationMessage("");
    setShowQRModal(false);
    setTimeout(() => {
      setShowQRModal(true);
    }, 100);
  };

  const constraints: MediaTrackConstraints = {
    facingMode: { ideal: "environment" }, // Use 'environment' for back camera or 'user' for front
    width: { ideal: 1280 },
    height: { ideal: 720 },
  };
  const handleScan = (result: any) => {
    if (result) {
      setIsScanning(false);
      console.log("QR Code Data:", result.text);
      setResult(result.text);
    }
  };

  const handleError = (err: any) => {
    console.error("Error:", err);
  };
  return (
    <Modal
      className="modalFullscreen"
      show={true}
      onHide={() => setShowQRModal(false)}
    >
      <Modal.Header>
        <div
          className="d-flex w-100"
          style={{ justifyContent: "space-between" }}
        >
          <div>
            <button
              className={classes.viewButton}
              onClick={() => window.location.reload()}
            >
              <FontIcon iconName="back" />
            </button>
          </div>
          <div className="d-flex" style={{ gap: 8 }}>
            {qrState != QrScanView.ARRIVED && (
              <Fragment>
                <Button
                  className={classes.blackButton}
                  style={{ width: "100%" }}
                >
                  <div
                    className="d-flex justify-content-center"
                    style={{ gap: 6 }}
                  >
                    <SofIcon iconname="QR" />
                    <div>Scan</div>
                  </div>
                </Button>
                {/* <button
                  className={classes.viewButton}
                  style={{ width: "auto", height: "41.99px" }}
                >
                  <div
                    className="d-flex justify-content-center px-3"
                    style={{ gap: 6 }}
                  >
                    <SofIcon iconname="Passkey" />
                    <div>Scan</div>
                  </div>
                </button> */}
              </Fragment>
            )}
          </div>
          <div></div>
        </div>
      </Modal.Header>
      <Modal.Body
        style={{
          height: "100vh",
        }}
      >
        {qrState == QrScanView.QRSCAN && (
          <div
            className="d-flex justify-content-center align-items-center h-100 qr-scanner-container"
            style={{
              background:
                "linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('/qr_bg.png') no-repeat center center",
              backgroundSize: "cover",
              backgroundPosition: "center center",
              backgroundRepeat: "no-repeat",
            }}
          >
            {isScanning && (
              <div
                className="qr-scan-frame d-flex justify-content-center align-items-center"
                style={{
                  background: "url('./qr_frame.png')",
                  height: "437px",
                  width: "437px",
                  backgroundSize: "cover",
                  backgroundRepeat: "no-repeat",
                }}
              >
                <QrReader
                  onResult={(result: any, error) => {
                    if (result) handleScan(result);
                    if (error) handleError(error);
                  }}
                  constraints={constraints}
                  videoStyle={{
                    width: "100%",
                    height: "auto",
                    maxWidth: 336,
                    maxHeight: 336,
                  }}
                />
              </div>
            )}
            {isLoading && (
              <div className="loading-scan-frame d-flex flex-column justify-content-center align-items-center">
                <div
                  style={{
                    width: "100px",
                    height: "100px",
                    border: "0.25em solid white",
                    borderRightColor: "transparent",
                  }}
                  className="spinner-border m-3"
                  role="status"
                >
                  <span className="visually-hidden"></span>
                </div>
                <h4 style={{ color: "white" }}>Processing</h4>
              </div>
            )}
          </div>
        )}
        {qrState == QrScanView.ARRIVED && (
          <div className="d-flex justify-content-center mt-5 h-100">
            <div className="d-flex flex-column align-items-center qr-scanner-success">
              <div className="d-flex justify-content-center mb-4">
                <SofIcon iconname="CheckMarkCircleIconV2" />
              </div>
              {linehandlingData && (
                <Fragment>
                  <h3 className="mb-3">
                    "RAIL {linehandlingData.railcars} status updated to
                    'Arrived'."
                  </h3>
                  <p>
                    You can now initiate operations required for RAIL{" "}
                    {linehandlingData.railcars}'s arrival.
                  </p>
                </Fragment>
              )}
            </div>
          </div>
        )}
        {qrState == QrScanView.QRNOTRECOGNIZED && (
          <div className="d-flex justify-content-center mt-5 h-100">
            <div className="d-flex flex-column align-items-center qr-scanner-validation">
              <div className="d-flex justify-content-center mb-4">
                <SofIcon iconname="QRError" />
              </div>
              {qrValidationMessage ? (
                <Fragment>
                  <h3 className="mb-3">Already Arrived</h3>
                  <p>{qrValidationMessage}</p>
                  <div className="mt-3">
                    <Button
                      className={classes.blackButton}
                      onClick={handleReinitialize}
                    >
                      <div
                        className="d-flex justify-content-center"
                        style={{ gap: 6 }}
                      >
                        <SofIcon iconname="QR" />
                        <div>Scan Again</div>
                      </div>
                    </Button>
                  </div>
                </Fragment>
              ) : (
                <Fragment>
                  <h3 className="mb-3">Unable to Recognize QR Code</h3>
                  <p>
                    We couldn’t read the QR code. Ensure it’s clear, well-lit,
                    and fully visible, then try again.
                  </p>
                  <div className="mt-3">
                    <Button
                      className={classes.blackButton}
                      onClick={handleReinitialize}
                    >
                      <div
                        className="d-flex justify-content-center"
                        style={{ gap: 6 }}
                      >
                        <SofIcon iconname="QR" />
                        <div>Scan Again</div>
                      </div>
                    </Button>
                  </div>
                </Fragment>
              )}
            </div>
          </div>
        )}
        {qrState == QrScanView.TRANSFERTOARRIVE && (
          <div className="d-flex justify-content-center mt-5">
            <div className="qr-scanner-verification w-100">
              <div className="d-flex align-items-center w-100 mb-3">
                <div className="mr-3">
                  {linehandlingData &&
                    linehandlingData.nominationType == "Load" && (
                      <SofIcon iconname="ArrowDownV2Colored" />
                    )}
                  {linehandlingData &&
                    linehandlingData.nominationType == "Discharge" && (
                      <SofIcon iconname="ArrowUpV2ColoredIcon" />
                    )}
                </div>
                <div className="header">
                  <h5> {linehandlingData && linehandlingData.nominationNo}</h5>
                  <span> {linehandlingData && linehandlingData.railcars}</span>
                </div>
              </div>
              <table className="w-100">
                <tbody>
                  <tr>
                    <td className="title">Rail Car #</td>
                    <td className="value">
                      {linehandlingData && linehandlingData.railcars}
                    </td>
                  </tr>
                  <tr>
                    <td className="title">Product</td>
                    <td className="value">
                      {linehandlingData && linehandlingData.product}
                    </td>
                  </tr>
                  <tr>
                    <td className="title">Quantity</td>
                    <td className="value">
                      {linehandlingData && linehandlingData.quantity}
                    </td>
                  </tr>
                  <tr>
                    <td className="title">Customer</td>
                    <td className="value">
                      {linehandlingData && linehandlingData.customer}
                    </td>
                  </tr>
                  <tr>
                    <td className="title">Date</td>
                    <td className="value">
                      {linehandlingData &&
                        linehandlingData.eta &&
                        moment.utc(linehandlingData.eta).local().format("ll")}
                    </td>
                  </tr>
                  <tr>
                    <td className="title">Time</td>
                    <td className="value">
                      {linehandlingData &&
                        linehandlingData.eta &&
                        moment
                          .utc(linehandlingData.eta)
                          .local()
                          .format("HH:mm")}
                    </td>
                  </tr>
                </tbody>
              </table>
              <div className="d-flex mt-4" style={{ gap: 8 }}>
                <Button
                  onClick={() => handleTransferToArrive()}
                  className={classes.blackButton}
                  style={{ width: "100%" }}
                >
                  Transfer to Arrived
                </Button>
                <button
                  onClick={() => setShowQRModal(false)}
                  className={classes.viewButton}
                  style={{ width: "100%", height: "41.99px" }}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};
export default QRScanner;
